import gsap from '../../js/gsap/gsap.min.js';
//import SplitText from '../../js/gsap/SplitText.min.js';
import { ScrollTrigger } from '../../js/gsap/ScrollTrigger.min.js';
import "../../js/theme/_lenis.js";


const header = document.getElementById("wrapper-navbar");
    header.classList.add("sticky");

function addClass() {
  header.classList.add('scrolling');
}
function removeClass() {
  header.classList.remove('scrolling')
}
ScrollTrigger.addEventListener('scrollStart', addClass)
ScrollTrigger.addEventListener('scrollEnd', removeClass)

let mm = gsap.matchMedia(); 
mm.add("(min-width: 1200px)", () => {
  const showAnim = gsap.from(header, { 
    yPercent: -100,
    paused: true,
    duration: 0.8,
    delay: 1,
  }).progress(1);
  
  ScrollTrigger.create({
    start: '400px',
    
    end: () => ScrollTrigger.maxScroll(window) + 10,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    },
    onLeave: () => showAnim.play()
  });

}); 


// const leaves = document.querySelectorAll('.leaf');

// const observer = new IntersectionObserver((entries, observer) => {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) {
//       const el = entry.target;
//       const position = el.dataset.position;

//       // Determine direction: -50 for "top", +50 for "bottom"
//       const translateY = position === 'top' ? -50 : 50;

//       gsap.fromTo(el, 
//         { y: translateY, opacity: 0 },
//         { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }
//       );

//       observer.unobserve(el); // animate only once
//     }
//   });
// }, {
//   threshold: 0.1
// });

// leaves.forEach(leaf => {
//   observer.observe(leaf);
// });

document.querySelectorAll('.leaf').forEach(leaf => {
  const position = leaf.dataset.position;
  const yStart = position === 'top' ? -50 : 50;
  const yEnd = position === 'top' ? 50 : -50;

  gsap.fromTo(leaf,
    { y: yStart},
    {
      y: yEnd,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: leaf,
        start: 'top 90%',   // when leaf's top hits 80% of viewport
        end: 'top top',     // animate until it hits 50%
        scrub: true,        // smooth scrubbing effect
        //markers: true
      },
    }
  );
});

if (document.querySelector("section") != null) {
  const coptions = {
    root: null
  };
  let revealCallback = entries => {
    entries.forEach(entry => {
      let container = entry.target;
      if (entry.isIntersecting) {
        // Check for the specific classes and add corresponding animation classes
        if (container.classList.contains("animatedFadeInUp")) {
          container.classList.add("fadeInUp");
        } else if (container.classList.contains("animatedFadeDown")) {
          container.classList.add("fadeInDown");
        }
      }
    });
  };
  let revealObserver = new IntersectionObserver(revealCallback, coptions);
  document.querySelectorAll(".animated").forEach(reveal => {
    revealObserver.observe(reveal);
  });
}

document.addEventListener("DOMContentLoaded", function () {
const footer = document.querySelector("#wrapper-footer");
const enquireBtn = document.querySelector(".enquire-btn");

    if (!footer || !enquireBtn) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            enquireBtn.classList.add("visible");
          } else {
            enquireBtn.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.3 // Trigger when at least 10% of the footer is visible
      }
    );

    observer.observe(footer);
  });
